import 'firebase/auth';

export default {
  treatmentHistoryDetails: {},
  createUserType: undefined,
};
